import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight, BookOpen } from 'lucide-react';
import blogPosts from '../data/blogPosts';

const Blog = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
  >
    <section className="Blog_hero__pUs4U">
      <div className="container Blog_heroContainer__r+TnE">
        <motion.span
          className="section-label"
          style={{ color: 'var(--c-gold)' }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          INSIGHTS &amp; GUIDANCE
        </motion.span>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          Career Counselling Blog
        </motion.h1>
        <motion.p
          className="Blog_heroSubtext__J9R9t"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          Expert articles on career guidance, psychometric assessments, stream
          selection, and professional growth by CCA Arendra Nath Sharma.
        </motion.p>
      </div>
    </section>

    <section className="section">
      <div className="container">
        <div className="Blog_postsGrid__pkn2a">
          {blogPosts.map((e, t) => (
            <motion.article
              key={e.slug}
              className="Blog_postCard__8zO34"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * t, duration: 0.4 }}
            >
              <div className="Blog_postMeta__nAF37">
                <span className="Blog_postCategory__8SO84">{e.category}</span>
                <span className="Blog_postDate__Od9DM">{e.date}</span>
              </div>
              <h2 className="Blog_postTitle__g+WX2">{e.title}</h2>
              <p className="Blog_postExcerpt__xyzdq">{e.excerpt}</p>
              <div className="Blog_postFooter__rhigf">
                <span className="Blog_readTime__5EFbz">
                  <Clock size={14} />
                  {e.readTime}
                </span>
                <Link to={`/blog/${e.slug}`} className="Blog_readMore__7hnEL">
                  Read More <ArrowRight size={14} />
                </Link>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>

    <section className="section section-alt">
      <div className="container Blog_blogCta__vmL0A">
        <BookOpen size={48} className="Blog_blogCtaIcon__Ja5G8" />
        <h2>Want Personalised Career Guidance?</h2>
        <p>
          Reading about career counselling is just the first step. Take the
          psychometric career assessment and get a detailed 20+ page report with
          a personalised execution plan.
        </p>
        <div className="Blog_blogCtaButtons__mUHfU">
          <a
            href="https://vitaecareer.edumilestones.com"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Explore Your True Potential
          </a>
          <Link to="/contact" className="btn-secondary">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  </motion.div>
);

export default Blog;
